import React from 'react'

export default (props) =>
  <div className="panel">
    <div className='panel-heading'>
      <h3 className='panel-head'>Trashcan</h3>
    </div>
    <div className='panel-body'>
      <ul>
        <li>File 1</li>
        <li>File 2</li>
        <li>File 3</li>
        <li>File 4</li>
      </ul>
    </div>
  </div>



// WEBPACK FOOTER //
// ./app/components/Trashcan.jsx